module.exports = __webpack_public_path__ + "static/media/launch_placeholder.c54b6d3f.png";